/**
 * Шторка снизу на половину экрана.
 *
 * Показывает подробности, не уводя с экрана: прежнее содержимое остаётся
 * видно за подложкой, и возврат ощущается как закрытие, а не как переход
 * назад. Для списков на десяток строк это дешевле отдельной страницы.
 *
 * Разметка присутствует всегда и переключается классом: появление и уход
 * должны быть анимированы, а элемент, добавляемый в DOM в момент открытия,
 * анимировать нечему.
 */
import type { ReactNode } from 'react';

import { useScrollLock } from '@/shared/lib/useScrollLock';

import styles from './Sheet.module.css';

interface Props {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  /** Высота по содержимому, а не половина экрана: для коротких форм
   *  с кнопкой внизу, которая иначе уезжает под край. */
  fit?: boolean;
}

export function Sheet({ open, title, onClose, children, fit = false }: Props) {
  useScrollLock(open);

  return (
    <>
      <div
        className={open ? `${styles.backdrop} ${styles.open}` : styles.backdrop}
        onClick={onClose}
        aria-hidden
      />
      <section
        className={[styles.sheet, fit ? styles.fit : '', open ? styles.open : '']
          .filter(Boolean)
          .join(' ')}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        <span className={styles.grabber} aria-hidden />
        <header className={styles.head}>
          <h2 className={styles.title}>{title}</h2>
          <button type="button" className={styles.close} onClick={onClose}>
            Закрыть
          </button>
        </header>
        <div className={styles.body}>{children}</div>
      </section>
    </>
  );
}
